import { render, staticRenderFns } from "./AccidentMobileCard.vue?vue&type=template&id=14aa10be&scoped=true&"
import script from "./AccidentMobileCard.vue?vue&type=script&lang=js&"
export * from "./AccidentMobileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aa10be",
  null
  
)

export default component.exports